import { gql } from '@apollo/client';
import FACILITY_FRAGMENT from '../fragments/facilityFragment';

const FACILITY_FULL_QUERY = gql`
  query facilityFull($id: ID!) {
    facility(id: $id) {
      ...FacilityFragment
    }
  }

  ${FACILITY_FRAGMENT}
`;

export default FACILITY_FULL_QUERY;
